/** Для проверки валидности ссылки  */
export const WEB_LINK_REGEXP =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/

/** Находит символы, которые не являются цифрами и точкой */
export const NOT_NUMBERS_REGEXP = /[^\d.]/g

export const TELEGRAM_REGEXP = /^@\w{2,}$/

export const ALL_EXCEPT_NUMBERS_REGEXP = /[^\d]/g

/** Находит символы, которые не являются кириллицей, латинницей и дефисом */
export const NOT_LATIN_CYRILLIC_HYPHEN = /[^a-zA-Zа-яА-ЯёЁ-]/g
export const NOT_LATIN_CYRILLIC = /[^a-zA-Zа-яА-ЯёЁ]/g
export const REPLACE_NOT_NUMBERS_REGEXP = /[^0-9.]/g

export const NUMBERS_REGEXP = /[0-9]/g

export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
